<div
   [ngClass]="{ 'vertical-group': smallView, 'horizontal-group': !smallView }"
   *samwebVar="presentationType$ | async; let presentationType"
>
   <fa-icon
      size="lg"
      *ngIf="presentationType?.showIcon"
      [style.color]="(actionContent$ | async).color"
      [ngClass]="{ 'vertical-icon': smallView, 'horizontal-icon': !smallView && presentationType?.showText }"
      [icon]="iconName$ | async | iconNameToIconDefinition$ | async"
   ></fa-icon>

   <ng-container *ngIf="presentationType?.showText && (actionContent$ | async).title as actionTitle">
      <div class="sam-ellipsis-on-overflow">{{ actionTitle }}</div>
   </ng-container>

   <ng-container *ngIf="presentationType?.showText && !(actionContent$ | async).title">
      <div class="sam-ellipsis-on-overflow action-title">
         {{ actionTitleTranslation$ | async | translate }}
      </div>
   </ng-container>

   <samweb-loading-indicator fxFlexFill [isLoading$]="isExecuting$"></samweb-loading-indicator>
</div>
